import { getAdminAuthHeader } from '@/lib/adminAuth';
import { getApiBase } from '@/lib/apiBase';

export type AdminRecordKind = 'request' | 'feedback' | 'contact' | 'career';

export async function deleteAdminRecord(kind: AdminRecordKind, id: string, type?: 'checkup' | 'sampling'): Promise<void> {
    const auth = getAdminAuthHeader();
    if (!auth) throw new Error('نشست مدیریت پایان یافته است. دوباره وارد شوید.');
    const response = await fetch(`${getApiBase()}/api/admin-delete.php`, {
        method: 'DELETE',
        headers: { Authorization: auth, 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind, id, type }),
    });
    if (response.status === 401) throw new Error('نشست مدیریت پایان یافته است. دوباره وارد شوید.');
    if (!response.ok) throw new Error(response.status === 404 ? 'این مورد قبلاً حذف شده است. فهرست را به‌روزرسانی کنید.' : 'حذف انجام نشد. دوباره تلاش کنید.');
}
